// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Hy8V","title":"Header_title__TUFGY","left":"Header_left__2xZL6","clinicName":"Header_clinicName__mmvoM"};